import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Button, Form, Label, Input, Row, Col, Table } from "reactstrap";
import axios from "axios";
import moment from "moment";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";

function ProcesosEntradaCreate() {
  const { user } = useContext(AuthContext);
  const URL_PROCESOS_SALIDA = process.env.REACT_APP_URL_PROCESOS_SALIDA;
  const URL_PROCESOS_ENTRADA = process.env.REACT_APP_URL_PROCESOS_ENTRADA;
  const URL_ARTICULOS_PROCESOS_SALIDA = process.env.REACT_APP_URL_ARTICULOS_PROCESOS_SALIDA;
  const URL_ARTICULOS_PROCESOS_ENTRADA = process.env.REACT_APP_URL_ARTICULOS_PROCESOS_ENTRADA;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;

  const hoy = moment().format("YYYY-MM-DD");
  const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };

  const [salidas, setSalidas] = useState([]);
  const [selectedSalida, setSelectedSalida] = useState("");
  const [salidaInfo, setSalidaInfo] = useState(null);
  const [fecha, setFecha] = useState(hoy);
  const [observaciones, setObservaciones] = useState("NA");
  const [renglones, setRenglones] = useState([]);
  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    axios.get(URL_PROCESOS_SALIDA, { headers })
      .then((res) => setSalidas((res.data || []).filter((a) => a.is_active === "Si" && a.status !== "Cerrado")))
      .catch((err) => console.log(err));
  }, []); // eslint-disable-line

  function cargaSalida(id) {
    setSelectedSalida(id);
    setRenglones([]);
    setSalidaInfo(salidas.find((a) => a._id === id) || null);
    if (!id) return;
    axios.get(`${URL_ARTICULOS_PROCESOS_SALIDA}/proceso/${id}`, { headers })
      .then((res) => {
        const filas = (res.data || [])
          .filter((a) => a.is_active === "Si")
          .map((a) => ({
            id: a._id,
            articulosPedido: a.articulosPedido?.[0]?._id || a.articulosPedido?.[0] || "",
            idColor: a.colores?.[0]?._id || "",
            idTalla: a.tallas?.[0]?._id || "",
            articulo: a.articulosPedido?.[0]?.articulos?.[0]
              ? `${a.articulosPedido?.[0]?.articulos?.[0]?.codigo || ""} ${a.articulosPedido?.[0]?.articulos?.[0]?.nombre || ""}`.trim()
              : "",
            color: a.colores?.[0] ? `${a.colores?.[0]?.name}` : "",
            talla: a.tallas?.[0]?.name || "",
            enviado: a.cantidadSalida || 0,
            recibido: a.cantidadEntrada || 0,
            pendiente: (a.cantidadSalida || 0) - (a.cantidadEntrada || 0),
            cantidadEntrada: 0,
            cantidadFaltantes: 0,
            cantidadSegundas: 0,
          }))
          .filter((a) => a.pendiente > 0);
        setRenglones(filas);
      })
      .catch((err) => console.log(err));
  }

  const cambia = (id, campo, valor) => {
    setRenglones((prev) =>
      prev.map((r) => (r.id === id ? { ...r, [campo]: parseFloat(valor) || 0 } : r))
    );
  };

  const totalPiezas = renglones.reduce((s, r) => s + r.cantidadEntrada, 0);
  const totalFaltantes = renglones.reduce((s, r) => s + r.cantidadFaltantes, 0);
  const totalSegundas = renglones.reduce((s, r) => s + r.cantidadSegundas, 0);
  const precio = parseFloat(salidaInfo?.precio) || 0;
  const totalGeneral = totalPiezas * precio;

  const guardar = (event) => {
    event.preventDefault();
    const aRecibir = renglones.filter((r) => r.cantidadEntrada > 0 || r.cantidadFaltantes > 0 || r.cantidadSegundas > 0);
    if (aRecibir.length === 0) {
      Swal.fire({ icon: "error", title: "Oops...", text: "Captura al menos una cantidad" });
      return;
    }
    const excedidos = aRecibir.filter((r) => r.cantidadEntrada + r.cantidadFaltantes + r.cantidadSegundas > r.pendiente);
    if (excedidos.length > 0) {
      Swal.fire({ icon: "error", title: "Oops...", text: `No puedes recibir mas de lo pendiente en: ${excedidos[0].articulo}` });
      return;
    }
    setValidaBoton(false);

    axios
      .post(URL_PROCESOS_ENTRADA, {
        proveedores: salidaInfo?.proveedores?.[0]?._id || salidaInfo?.proveedores?.[0],
        pedidos: salidaInfo?.pedidos?.[0]?._id || salidaInfo?.pedidos?.[0],
        procesosSalida: selectedSalida,
        fecha,
        observaciones,
        totalGeneral,
        totalPiezas,
        totalPiezasFaltantes: totalFaltantes,
        totalPiezasSegundas: totalSegundas,
        precio,
      }, { headers })
      .then((data) => {
        const idEntrada = data.data._id;
        Promise.all(
          aRecibir.map((r) =>
            axios.post(URL_ARTICULOS_PROCESOS_ENTRADA, {
              procesosEntrada: idEntrada,
              articulosPedido: r.articulosPedido,
              articulosProcesosSalida: r.id,
              pedidos: salidaInfo?.pedidos?.[0]?._id || salidaInfo?.pedidos?.[0],
              proveedores: salidaInfo?.proveedores?.[0]?._id || salidaInfo?.proveedores?.[0],
              cantidadEntrada: r.cantidadEntrada,
              cantidadFaltantes: r.cantidadFaltantes,
              cantidadSegundas: r.cantidadSegundas,
              precio,
              fecha,
              colores: r.idColor,
              tallas: r.idTalla,
            }, { headers })
          )
        ).then(() => {
          axios.post(URL_LOGS, {
            tipo: "Entrada de Maquila",
            detalle: `Salida ${salidaInfo?.idProcesosSalida || selectedSalida} / ${totalPiezas} pzs`,
            user: user.id,
          }, { headers });
          Swal.fire("Good job!", "Creado con exito", "success");
          setTimeout(() => { window.location.reload(); }, 1500);
        });
      })
      .catch((error) => {
        setValidaBoton(true);
        Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!",
          footer: `${error.response?.data?.message || error.message}` });
      });
  };

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_procesos ? (
        <div className="card container col-11">
          <h3 align="center">Entrada de Maquila</h3>
          <Form onSubmit={guardar}>
            <Row>
              <Col md={3}>
                <Label>Fecha</Label>
                <Input type="date" value={fecha} required onChange={(e) => setFecha(e.target.value)} />
              </Col>
              <Col md={5}>
                <Label>Salida a Maquila</Label>
                <Input type="select" value={selectedSalida} required onChange={(e) => cargaSalida(e.target.value)}>
                  <option value="">Selecciona</option>
                  {salidas
                    .sort((a, b) => (a.idProcesosSalida > b.idProcesosSalida ? 1 : -1))
                    .map((a) => (
                      <option key={a._id} value={a._id}>
                        {a.idProcesosSalida} - {a.proveedores?.[0]?.nombre_comercial || ""} - {a.fecha}
                      </option>
                    ))}
                </Input>
              </Col>
              <Col md={4}>
                <Label>Observaciones</Label>
                <Input type="text" value={observaciones} required onChange={(e) => setObservaciones(e.target.value)} />
              </Col>
            </Row>
            <br />

            {renglones.length > 0 ? (
              <>
                <Table size="sm" striped borderless className="table-responsive-xl">
                  <thead>
                    <tr>
                      <th className="tituloTabla">Articulo</th>
                      <th className="tituloTabla">Color</th>
                      <th className="tituloTabla">Talla</th>
                      <th className="tituloTabla" align="right">Enviado</th>
                      <th className="tituloTabla" align="right">Pendiente</th>
                      <th className="tituloTabla" align="right">Recibe</th>
                      <th className="tituloTabla" align="right">Faltantes</th>
                      <th className="tituloTabla" align="right">Segundas</th>
                    </tr>
                  </thead>
                  <tbody>
                    {renglones.map((r) => (
                      <tr key={r.id}>
                        <td>{r.articulo}</td>
                        <td>{r.color}</td>
                        <td>{r.talla}</td>
                        <td align="right">{r.enviado}</td>
                        <td align="right">{r.pendiente}</td>
                        <td style={{ maxWidth: "100px" }}>
                          <Input type="number" min="0" step="any" value={r.cantidadEntrada}
                            onChange={(e) => cambia(r.id, "cantidadEntrada", e.target.value)} />
                        </td>
                        <td style={{ maxWidth: "100px" }}>
                          <Input type="number" min="0" step="any" value={r.cantidadFaltantes}
                            onChange={(e) => cambia(r.id, "cantidadFaltantes", e.target.value)} />
                        </td>
                        <td style={{ maxWidth: "100px" }}>
                          <Input type="number" min="0" step="any" value={r.cantidadSegundas}
                            onChange={(e) => cambia(r.id, "cantidadSegundas", e.target.value)} />
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td colSpan="5" align="right"><b>Totales</b></td>
                      <td align="right"><b>{new Intl.NumberFormat("en-US").format(totalPiezas)}</b></td>
                      <td align="right"><b>{new Intl.NumberFormat("en-US").format(totalFaltantes)}</b></td>
                      <td align="right"><b>{new Intl.NumberFormat("en-US").format(totalSegundas)}</b></td>
                    </tr>
                    <tr>
                      <td colSpan="7" align="right"><b>Total a Pagar</b></td>
                      <td align="right"><b>
                        {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(totalGeneral)}
                      </b></td>
                    </tr>
                  </tbody>
                </Table>
                <br />
              </>
            ) : selectedSalida ? (
              <h6 align="center">Esta salida ya no tiene piezas pendientes de recibir.</h6>
            ) : undefined}

            <Row>
              <Col md={12} align="center">
                {validaBoton ? (
                  <Button type="submit" className="btn btn-success">Guardar</Button>
                ) : (
                  <Button type="submit" className="btn btn-success" disabled>Guardar</Button>
                )}
                <Button href="/MenuProduccion" className="btn btn-danger">Regresar</Button>
              </Col>
            </Row>
          </Form>
        </div>
      ) : undefined}
    </>
  );
}

export default ProcesosEntradaCreate;
